<template>
  <div class="select-lists">
    <div class="select-lists.list" v-if="lists.length > 0">
      <div
        class="select-lists.card"
        v-for="(item, index) in lists"
        :key="index"
        @click="goDetail(item)"
        data-aos="zoom-in-up"
      >
        <h4>{{ item.title +" | "+ item.pub_card }}</h4>
        <p>{{ item.desc.substring(0, 140) + "......" }}</p>
        <div class="more">
          <span>更多</span>
          <img src="../assets/more.png" />
        </div>
      </div>
    </div>
    <div class="select-lists.nodata" v-else>暂无数据</div>
    <div
      class="select-lists.page"
      v-show="pageParams.totalMCount > this.pagePer"
    >
      <el-pagination
        background
        layout="prev, pager, next"
        :hide-on-single-page="true"
        @size-change="handleMChange"
        @current-change="handleMCurrentChange"
        :current-page.sync="pageParams.pageMNo"
        :page-size="pageSize"
        :total="pageParams.totalMCount"
      >
      </el-pagination>
    </div>
    <consultation-modal
      :consultationShow="consultationShow"
      @closeConsultationEvent="closeConsultationEvent"
    ></consultation-modal>
  </div>
</template>

<script>
import ConsultationModal from "../components/consultation-modal.vue";
export default {
  props: {
    lists: {
      string: Array,
      default: () => {
        return [];
      },
    },
    pageParams: {
      string: Object,
      default: () => {
        return {};
      },
    },
    pageSize: {
      string: Number,
      default: 16,
    },
  },
  components: {
    ConsultationModal,
  },
  data() {
    return {
      consultationShow: false,
    };
  },
  methods: {
    goDetail(row) {
      let path =
        (this.$route.path == "/" ? "Patent" : this.$route.path) + "/" + row.id;
      // sessionStorage.setItem("detail", JSON.stringify(row));
      if (row.type) {
        switch (row.type) {
          case "版权":
            path = `/Copyright/${row.id}`;
            break;
          case "商标":
            path = `/Trademark/${row.id}`;
            break;
          case "专利":
            path = `/Patent/${row.id}`;
            break;
          default:
            path = this.$router.push(this.$route.path + "/" + row.id);
        }
      }
      //this.$router.push(path)

      let routeUrl = this.$router.resolve({
        path: path,
      });
      window.open(
        location.pathname + "#" + routeUrl.resolved.fullPath,
        "_blank"
      ); //线上发布用
    },
    consulationList(event) {
      event.stopPropagation();
      this.consultationShow = true;
    },
    getPageMData() {
      this.$emit("updateLists", this.pageParams.pageMNo);
    },
    handleMChange(val) {
      this.$nextTick(() => {
        this.getPageMData();
      });
    },
    handleMCurrentChange(val) {
      this.getPageMData();
    },
    closeConsultationEvent(val) {
      this.consultationShow = val;
    },
  },
};
</script>

<style lang="scss" scoped>
@include component(select-lists) {
  width: 100%;
  color: #333333;

  @include part(list) {
    width: 100%;
    //box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    margin: 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
  }

  @include part(card) {
    width: 100%;
    height: 158px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    //overflow: hidden;
    border: none;
    box-sizing: border-box;
    padding: 26px 24px 16px;
    margin-bottom: 20px;
    border: 1px solid transparent;
    cursor: pointer;
    position: relative;
    &:hover {
		border: 1px solid #2278fc;
		h4{
			color: #2278fc;
		}
    }
    h4 {
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      margin: 0;
      text-align: left;
      position: relative;
      padding-left: 10px;
      &::before {
        position: absolute;
        content: "";
        width: 3px;
        height: 24px;
        background: #2278fc;
        top: 0;
        left: 0;
      }
    }
    p {
      margin: 14px 0;
      font-size: 16px;
      font-weight: 400;
      color: #999999;
      text-align: left;
    }
    .more {
		position: absolute;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		right: 24px;
		bottom: 16px;
      span {
        font-size: 16px;
        font-weight: 400;
        color: #2278fc;
		margin-right: 5px;
      }
	  img{
		  width: 16px;
		  height: 16px;
	  }
    }
  }

  @include part(page) {
    width: 100%;
    height: 80px;
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @include part(nodata) {
    width: 100%;
    height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
